export default "__VITE_ASSET__BuckYml1__"